<!-- 保存曲线 -->
<template>
  <div>
    <el-form ref="dataForm" :model="dialogObj" :rules="popRules" label-width="120px">
      <el-form-item :label="'曲线文件'">
        <input type="file" @change="fileChange">
        <p>标准文件命名：GPData_1524_312.PYL</p>
      </el-form-item>
      <div class="flex_wrap">
        <el-form-item :label="$t('adminView.curveNumber')" prop="curveNumber">
          <el-input v-model="dialogObj.curveNumber" />
        </el-form-item>
        <el-form-item :label="$t('adminView.manufacturer')" prop="manufacturer">
          <el-input v-model="dialogObj.manufacturer" />
        </el-form-item>
        <el-form-item :label="$t('adminView.descriptions') + '(名称)'" prop="descriptions">
          <el-input v-model="dialogObj.descriptions" />
        </el-form-item>
        <el-form-item :label="$t('adminView.capacity')">
          <el-input v-model="dialogObj.capacity" />
        </el-form-item>
        <el-form-item :label="$t('adminView.battery')">
          <el-input v-model="dialogObj.battery" />
        </el-form-item>
        <el-form-item :label="$t('warningPage.Remark')">
          <el-input v-model="dialogObj.remark" />
        </el-form-item>
      </div>
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="3012">
            <el-input v-model="dialogObj.g3012" type="textarea" :rows="dialogObj.g3012? 10:1"/>
          </el-form-item>
          <el-form-item label="1524">
            <el-input v-model="dialogObj.g1524" type="textarea" :rows="dialogObj.g1524? 10:1"/>
          </el-form-item>
          
          <el-form-item label="3024">
            <el-input v-model="dialogObj.g3024" type="textarea" :rows="dialogObj.g3024? 10:1"/>
          </el-form-item>
          <el-form-item label="3624">
            <el-input v-model="dialogObj.g3624" type="textarea" :rows="dialogObj.g3624? 10:1"/>
          </el-form-item>
          <el-form-item label="6024">
            <el-input v-model="dialogObj.g6024" type="textarea" :rows="dialogObj.g6024? 10:1"/>
          </el-form-item>
          
          <el-form-item label="8080">
            <el-input v-model="dialogObj.g8080" type="textarea" :rows="dialogObj.g8080? 10:1"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          
          <el-form-item label="1548">
            <el-input v-model="dialogObj.g1548" type="textarea" :rows="dialogObj.g1548? 10:1"/>
          </el-form-item>
          <el-form-item label="2548">
            <el-input v-model="dialogObj.g2548" type="textarea" :rows="dialogObj.g2548? 10:1"/>
          </el-form-item>
          <el-form-item label="3548">
            <el-input v-model="dialogObj.g3548" type="textarea" :rows="dialogObj.g3548? 10:1"/>
          </el-form-item>
          <el-form-item label="6048">
            <el-input v-model="dialogObj.g6048" type="textarea" :rows="dialogObj.g6048? 10:1"/>
          </el-form-item>
          <el-form-item label="10048">
            <el-input v-model="dialogObj.g10048" type="textarea" :rows="dialogObj.g10048? 10:1"/>
          </el-form-item>

        </el-col>

        <el-col :span="8">
          
          <el-form-item label="2036">
            <el-input v-model="dialogObj.g2036" type="textarea" :rows="dialogObj.g2036? 10:1"/>
          </el-form-item>
          <el-form-item label="2536">
            <el-input v-model="dialogObj.g2536" type="textarea" :rows="dialogObj.g2536? 10:1"/>
          </el-form-item>
          <el-form-item label="3536">
            <el-input v-model="dialogObj.g3536" type="textarea" :rows="dialogObj.g3536? 10:1"/>
          </el-form-item>
          <el-form-item label="2572">
            <el-input v-model="dialogObj.g2572" type="textarea" :rows="dialogObj.g2572? 10:1"/>
          </el-form-item>
          <el-form-item label="4072">
            <el-input v-model="dialogObj.g4072" type="textarea" :rows="dialogObj.g4072? 10:1"/>
          </el-form-item>

        </el-col>
      </el-row>

    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="$emit('close')">{{ $t('button.Cancel') }}</el-button>
      <el-button type="primary" @click="submitForm('dataForm')">{{ $t('button.Submit') }}</el-button>

      <el-button @click="$emit('nextRow')">下一条</el-button>
    </div>
  </div>
</template>

<script>
import { addCurveNumberInfo, updateCurveNumberInfo } from '@/api/settingBattery'
export default {
  components: {},
  props: ['isAdd', 'row'],
  data () {
    return {
      dialogObj: {}
    };
  },
  computed: {
    popRules () {
      return {
        curveNumber: [{ required: true, message: this.$t('lease.Cannotbeblanked2'), trigger: 'blur' }],
        manufacturer: [{ required: true, message: this.$t('lease.Cannotbeblanked2'), trigger: 'blur' }],
        descriptions: [{ required: true, message: this.$t('lease.Cannotbeblanked2'), trigger: 'blur' }]
      }
    }
  },
  mounted () {
    this.dialogObj = this.row
  },
  methods: {
    fileChange (e) {
      const file = e.target.files[0]
      let fname = file.name
      const index = fname.indexOf('.')
      if (index > 0) {
        fname = fname.slice(0, index)
      }
      const nameArr = fname.split('_');
      if (nameArr.length != 3) return
      const mech = 'g'+ nameArr[1]
      if (this.isAdd) {
        this.dialogObj.curveNumber = nameArr[2]
        // this.dialogObj.manufacturer = nameArr[0]
        this.dialogObj.descriptions = nameArr[1]
      }else {
        if (this.dialogObj.curveNumber == nameArr[2]) {

        }else {
          this.$notify({
            title: '',
            message: '曲线号不匹配',
            type: 'error',
            duration: 2000
          })
          return
        }
      }
      const fileRe = new FileReader();
      fileRe.onload = (e) => {
        const res = e.target.result
        this.dialogObj[mech] = res
      }
      fileRe.readAsBinaryString(file)
    },
    resHandle (res) {
      if (res.resultCode == 1001) {
        this.$notify({
          title: '',
          message: this.$t('lease.Succeed'),
          type: 'success',
          duration: 2000
        })
        this.$emit('close')
      }else {
        this.$notify({
          title: '',
          message: res.resultModel,
          type: 'error',
          duration: 2000
        })
      }
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // if (this.dialogObj.curveNumber) {
          //   var firstS = this.dialogObj.curveNumber[0]
          //   // 如果首字母不是b且不是数字 或 首字母是b但不含数字
          //   if ((firstS != 'b' && !/^[0-9]*$/.test(firstS)) || (firstS == 'b' && !/^(?=.*\d.*\b)/.test(this.dialogObj.curveNumber))) {
          //     this.$notify({
          //       title: '',
          //       message: this.$t('adminView.EnterCorrect'), // '请输入正确的曲线号。如: b123/123',
          //       type: 'error',
          //       duration: 2000
          //     })
          //     return
          //   }
          // }
          if (this.isAdd) { // 新增
            addCurveNumberInfo(this.dialogObj).then(res => {
              this.resHandle(res)
            })
          } else {
            updateCurveNumberInfo(this.dialogObj).then(res => {
              this.resHandle(res)
            })
          }
        }
      })
    }
  }
}
</script>

<style lang='scss' scoped>
</style>
